<template>

    <div class="row justify-content-center">
        <div class="col-md-8">
            <div class="text-center mt-2">
                <div class="intro-img flex justify-center">
                    <img src="/images/animat-paper-airplane-color.gif">
                </div>
                <h4>
                    {{title}}
                </h4>
                <p class="intro-copy ml-auto mr-auto" style="max-width: 500px;">
                    {{message}}
                </p>
                <div class="intro-btn" v-if="userCan('manage-mailboxes') && teamIsActive()">
                    <a href="/settings#/tab-mailboxes" class="btn btn-outline-primary">
                        View Mailboxes
                    </a>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
  export default {

    computed: {
      title() {
        return "You don't have access to any mailboxes yet";
      },

      message() {

        if (this.teamIsActive()) {
          return this.userCan("manage-mailboxes") ?
            "Setup your mailboxes to start sending and receiving emails in App!"
            : "Ask your account owner or manager to give you permission to view your mailbox!";
        } else {
          return "After activating your subscription and setting up your mailbox this is where you'll view all your emails sent and received with App.";
        }

      }
    }

  };
</script>
